import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {CalendarShare} from '../../models/calendar/calendarshare';
import {CalendarDepartShare} from '../../models/calendar/calendardepartshare';
import {CalendarShareUser} from '../../models/calendar/calendarshareuser';
const apiUrl = `${environment.apiUrl}/api/calendar/calendarshare`;

@Injectable({
  providedIn: 'root'
})
export class CalendarShareService {
  constructor(public httpService: HttpClient) { }


  public add(params: Object): Observable<CalendarShare>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new CalendarShare().deserialize(data)));

  }


  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  public addMulti(id: number, unitsId : string): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/addmulti/${id}?uids=${unitsId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id add not found'))
    );
  }

  public addMultiCalendar(id: string, unitsId : string): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/addmulticalendar?id=${id}&uids=${unitsId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id add not found'))
    );
  }
  public deleteMulti(id: number, unitsId : string): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/deletemulti/${id}?uids=${unitsId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id add not found'))
    );
  }
  public deleteShareUserMulti(id: number, unitsId : string): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/deleteshareusermulti/${id}?uids=${unitsId}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id add not found'))
    );
  }

  findAllByCalendarId(calendarId: number): Observable<CalendarShare[]> {
    return this.httpService.get<CalendarShare[]>(`${apiUrl}/findallbycalendarid/${calendarId}`).pipe(
      map(data => data.map(data => new CalendarShare().deserialize(data)))
    );
  }
  findAllShareUserByCalendarId(calendarId: number): Observable<CalendarShareUser[]> {
    return this.httpService.get<CalendarShareUser[]>(`${apiUrl}/findallshareuserbycalendarid/${calendarId}`).pipe(
      map(data => data.map(data => new CalendarShareUser().deserialize(data)))
    );
  }
  findAllByCalendarMulti(calendarId: string): Observable<CalendarShare[]> {
    return this.httpService.get<CalendarShare[]>(`${apiUrl}/findallbycalendarmulti?cid=${calendarId}`).pipe(
      map(data => data.map(data => new CalendarShare().deserialize(data)))
    );
  }
}
